import {ReductionsState} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/reductions_state.types';
import {useCallback, useMemo} from 'react';
import {useUnlockedCouponTokens} from '../Coupons/useUnlockedCouponTokens';

/**
 * `useReductionsStateRequestParameter` returns a deferred value, which allows refetching the requests whenever the selected discount changes without
 * blocking the current UI updates/animations.
 */
export const useReductionsStateRequestParameter = (): ReductionsState => {
  const {unlockedCouponTokens} = useUnlockedCouponTokens();

  return useMemo(() => {
    return {
      unlockedCouponTokens: unlockedCouponTokens
        ? {unlockedCouponTokens}
        : undefined,
    };
  }, [unlockedCouponTokens]);
};

export const useReductionsStateRequestParameterCallback =
  (): (() => Promise<ReductionsState>) => {
    const {unlockedCouponTokens} = useUnlockedCouponTokens();

    return useCallback(async () => {
      return {
        unlockedCouponTokens: unlockedCouponTokens
          ? {unlockedCouponTokens}
          : undefined,
      };
    }, [unlockedCouponTokens]);
  };
